var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 2.6665C9.37854 2.6665 10.6859 3.14489 11.8241 4.03054C12.9623 4.90974 13.9314 6.1962 14.6273 7.8059C14.6793 7.92873 14.6793 8.07095 14.6273 8.18731C13.2354 11.4067 10.7574 13.3332 7.99967 13.3332H7.99317C5.24195 13.3332 2.7639 11.4067 1.37203 8.18731C1.32 8.07095 1.32 7.92873 1.37203 7.8059C2.7639 4.5865 5.24195 2.6665 7.99317 2.6665H7.99967ZM7.99967 5.41398C6.56228 5.41398 5.39805 6.57115 5.39805 7.99984C5.39805 9.42206 6.56228 10.5792 7.99967 10.5792C9.43057 10.5792 10.5948 9.42206 10.5948 7.99984C10.5948 6.57115 9.43057 5.41398 7.99967 5.41398ZM8.00046 6.38225C8.89151 6.38225 9.61997 7.10629 9.61997 7.99841C9.61997 8.88407 8.89151 9.60811 8.00046 9.60811C7.10289 9.60811 6.37444 8.88407 6.37444 7.99841C6.37444 7.88851 6.38745 7.78508 6.40696 7.68165H6.43948C7.16143 7.68165 7.7468 7.11276 7.77281 6.40165C7.84436 6.38872 7.92241 6.38225 8.00046 6.38225Z",
    fill: "#333333",
    fillOpacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.478eaa44.svg";
export { ForwardRef as ReactComponent };